import { Money } from '@dev-togetherprice/monetary';
import { promoApplicableDiscountForFirstPayment, promoApplicableDiscountForRenew, } from '@dev-togetherprice/constants.promo';
export var DURATION;
(function (DURATION) {
    DURATION["ANNUAL"] = "ANNUAL";
    DURATION["MONTHLY"] = "MONTHLY";
})(DURATION || (DURATION = {}));
export const getDiscountedAmount = (amount, discount) => {
    if (amount.currency !== discount.currency) {
        throw new Error('Currencies must be equal');
    }
    const zero = Money.zero(amount.currency);
    const correctAmount = Money.max(amount, zero);
    const correctDiscount = Money.max(discount, zero);
    return Money.max(Money.from(correctAmount).subtract(correctDiscount), Money.zero(amount.currency));
};
export const hasSameFrequency = (token, post) => token.frequency.toLocaleLowerCase() === post.frequency.toLocaleLowerCase();
export const isDiscounted = (discounted, original) => Money.from(discounted).subtract(original).isNegative();
export const isPromoTokenActiveAndNotReserved = (token) => { var _a; return !!((token === null || token === void 0 ? void 0 : token.active) && !((_a = token === null || token === void 0 ? void 0 : token.request) === null || _a === void 0 ? void 0 : _a.sharingPostId)); };
export const isPromoTokenApplicable = (token, post, isRenew) => {
    if (!isPromoTokenActiveAndNotReserved(token)) {
        return false;
    }
    if (!(isRenew
        ? promoApplicableDiscountForRenew
        : promoApplicableDiscountForFirstPayment).includes(token.discountFor)) {
        return false;
    }
    if (token.frequency === 'ALL' || hasSameFrequency(token, post)) {
        return true;
    }
    return false;
};
export const findTokenFor = (tokens, variant, isRenew) => tokens.find(({ active, discountOn, discountFor }) => active
    && discountOn === variant
    && (isRenew
        ? promoApplicableDiscountForRenew.includes(discountFor)
        : promoApplicableDiscountForFirstPayment.includes(discountFor)));
export const getDiscountedPostPrice = (post, tokens, hasNoFee = false, isRenew = false) => {
    const { monthlyPrice } = post;
    let { feePrice } = post;
    const priceNoFee = Money.from(monthlyPrice).subtract(feePrice);
    let feeDiscounted = Money.from(feePrice);
    let amountDiscounted = Money.from(priceNoFee);
    if (hasNoFee) {
        feePrice = Money.zero(feePrice.currency);
        feeDiscounted = Money.zero(feePrice.currency);
    }
    const amountToken = findTokenFor(tokens, 'AMOUNT', isRenew);
    const feeToken = findTokenFor(tokens, 'FEE', isRenew);
    // compute amount discounted
    if (amountToken && isPromoTokenApplicable(amountToken, post, isRenew)) {
        amountDiscounted = getDiscountedAmount(priceNoFee, amountToken.amount);
    }
    // compute fee discounted
    if (feeToken && isPromoTokenApplicable(feeToken, post, isRenew)) {
        feeDiscounted = getDiscountedAmount(feeDiscounted, feeToken.amount);
    }
    // checks for a valid combination of tokens
    /**
     * While stripe does not accept transaction less than 0.5
     * We need to check the best condition than will be greater than 0.5
     * or equals to zero.
     */
    const fullSales = amountDiscounted.add(feeDiscounted);
    if (fullSales.isNegativeOrZero() || fullSales.value >= 0.5) {
        return fullSales;
    }
    const amountSales = amountDiscounted.add(feePrice);
    if (amountSales.isNegativeOrZero() || amountSales.value >= 0.5) {
        return amountSales;
    }
    const feeSales = priceNoFee.add(feeDiscounted);
    if (feeSales.isNegativeOrZero() || feeSales.value >= 0.5) {
        return feeSales;
    }
    // no discount applicable
    return Money.from(priceNoFee).add(feePrice);
};
